import { z } from "zod";
import { containerSchema } from "./container.js";
/** Wire validation for {@link ContainerEntryContext}: only readable levels. */
export const containerEntryContextSchema = z.object({
    id: z.string(),
    name: z.string(),
    owner: z.string(),
    level: z.enum(["owner", "read", "write", "admin"]),
});
/**
 * `GET /api/containers/:id/entry` response (catalog-entry-sharing 11): the
 * read container plus the entry it belongs to.
 */
export const containerEntryResponseSchema = z.object({
    container: containerSchema,
    entry: containerEntryContextSchema,
});
//# sourceMappingURL=container-entry.js.map